'use strict';

var FIELDS = {
    FIELD_FIRST_NAME: 'firstName',
    FIELD_LAST_NAME: 'lastName',
    FIELD_COMPANY: 'company',
    FIELD_LINE1: 'line1',
    FIELD_LINE2: 'line2',
    FIELD_COUNTRY: 'country',
    FIELD_CITY: 'city',
    FIELD_STATE: 'state',
    FIELD_ZIP_CODE: 'zipCode',
    FIELD_PHONE_NUMBER: 'phoneNumber'
};

var fields = [
    FIELDS.FIELD_FIRST_NAME,
    FIELDS.FIELD_LAST_NAME,
    FIELDS.FIELD_COMPANY,
    FIELDS.FIELD_LINE1,
    FIELDS.FIELD_LINE2,
    FIELDS.FIELD_COUNTRY,
    FIELDS.FIELD_CITY,
    FIELDS.FIELD_STATE,
    FIELDS.FIELD_ZIP_CODE,
    FIELDS.FIELD_PHONE_NUMBER
];

var optionalFields = [
    FIELDS.FIELD_COMPANY,
    FIELDS.FIELD_LINE2
];

var regexMap = {
    specialCharacters: /[!@#$%^&*()+=><?]/,
    specialCharactersAddress: /[!@$%^&*()+=><?]/,
    poBox: /^.*P(\.|\s|OST)*O(\.|\s|FFICE)*b\s*o\s*x.*$/i,
    globalZipCode: /^(?!((\w|\s|-){1,9})$)/,
    usZipCode: /^(?!(\d{5}(?:[-\s]?\d{4})?$))/,
    usZipCodeShort: /^(?!(\d{5}?$))/,
    all: /^(?!(.*))/
};

module.exports = {
    FIELDS: FIELDS,
    fields: fields,
    optionalFields: optionalFields,
    regexMap: regexMap
};



//////////////////
// WEBPACK FOOTER
// ./~/dibs-address-validator/constants.js
// module id = 659
// module chunks = 4 7 13 14 20